import Translation from 'constants/languages';

export default {
  requiredField: {
    [Translation.English]: 'Required Field',
    [Translation.Greek]: 'Υποχρεωτικό πεδίο',
    [Translation.German]: 'Pflichtfeld',
    [Translation.Italian]: 'Campo obbligatorio',
  },
};
